import { Table, Container, Card, Row, Col } from 'react-bootstrap';
import { Button, Modal } from "react-bootstrap";
import { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaHome } from 'react-icons/fa';

import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { protectedResources, scopes } from "../authConfig";
import UserEditForm from '../components/UserEditForm';
import { useNavigate } from 'react-router-dom';

export const UserManagement = (props) => {
    const { execute } = useFetchWithMsal({
        scopes: scopes.callapi
    });

    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [show, setShow] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [isUpdate, setIsUpdate] = useState(false);

    // 権限タイプを名称に変換する関数
    const getPermissionName = (permissionType) => {
        switch (permissionType) {
            case 1: return "一般ユーザー";
            case 2: return "事務局";
            case 3: return "人事";
            case 4: return "管理者";
            default: return permissionType;
        }
    };

    function handleEditClick(user) {
        console.log("call handleEditClick");
        setSelectedUser(user);
        setShow(true);
    }

    function handleDeleteClick(user) {
        const response = execute("DELETE", protectedResources.deleteUser.endpoint, user);
        console.log("response" + response);
        setIsUpdate(true);
    }

    const navigate = useNavigate();
    const handleButtonClick = (managementType) => {
        navigate(`/`);
    };

    useEffect(() => {

        const fetchUserList = async () => {
            console.log("call fetchUserList");
            try {
                setLoading(true);
                const response = await execute("GET", protectedResources.getUsers.endpoint, "")
                if (!response || !response.ok) {
                }
                const data = response;
                setUsers(data);
                setLoading(false);
                setIsUpdate(false);
                console.log("data:" + data);
            } catch (error) {
                console.log("error:" + error);
            }
        };
        fetchUserList();
    }, [execute, isUpdate]);

    if (loading) return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: "300px" }}>
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );

    return (
        <>
            <Container className="py-5">
                <Card className="border-0 shadow-sm">
                    <Card.Body>
                        <Row className="align-items-center mb-4">
                            <Col>
                                <h2 className="mb-0 fw-bold">ユーザー一覧</h2>
                            </Col>
                            <Col xs="auto">
                                <div className="d-flex gap-2">
                                    <Button 
                                        className="d-flex align-items-center gap-2" 
                                        variant="primary" 
                                        onClick={() => { setSelectedUser({}); setShow(true); }}
                                    >
                                        <FaPlus /> 新規作成
                                    </Button>
                                    <Button 
                                        className="d-flex align-items-center gap-2" 
                                        variant="outline-secondary" 
                                        onClick={() => handleButtonClick()}
                                    >
                                        <FaHome /> 管理者トップページ
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        
                        <div className="table-responsive">
                            <Table hover className="align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th>ログイン名</th>
                                        <th>表示名</th>
                                        <th>会社名</th>
                                        <th>権限</th>
                                        <th>氏名</th>
                                        <th>状態</th>
                                        <th className="text-center">操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(users) && users.map(((user) =>
                                        <tr key={user.id}>
                                            <td>{user.loginName}</td>
                                            <td>{user.displayName}</td>
                                            <td>{user.companyName}</td>
                                            <td>{getPermissionName(user.PermissionType)}</td>
                                            <td>{`${user.surname} ${user.givenName}`}</td>
                                            <td>
                                                <span className={`badge ${user.accountEnabled ? 'bg-success' : 'bg-danger'}`}>
                                                    {user.accountEnabled ? '有効' : '無効'}
                                                </span>
                                            </td>
                                            <td>
                                                <div className="d-flex justify-content-center gap-2">
                                                    <Button 
                                                        variant="outline-primary" 
                                                        size="sm" 
                                                        className="d-flex align-items-center" 
                                                        onClick={() => handleEditClick(user)}
                                                    >
                                                        <FaEdit />
                                                    </Button>
                                                    <Button 
                                                        variant="outline-danger" 
                                                        size="sm" 
                                                        className="d-flex align-items-center" 
                                                        onClick={() => handleDeleteClick(user)}
                                                    >
                                                        <FaTrash />
                                                    </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                        
                        <Modal show={show} onHide={() => { setShow(false); setSelectedUser(null); }} size="lg">
                            <Modal.Header closeButton className="bg-light">
                                <Modal.Title>{selectedUser?.id ? 'ユーザー編集' : 'ユーザー新規作成'}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body className="p-4">
                                {selectedUser && <UserEditForm user={selectedUser} onDone={() => { setShow(false); setSelectedUser(null); setIsUpdate(true); }} />}
                            </Modal.Body>
                        </Modal>
                    </Card.Body>
                </Card>
            </Container>
        </>
    );
};
